interface CmdKLookupHintProps {
  type: string;
  id: string;
}

/**
 * Shows a hint when user has typed a lookup command prefix.
 */
export function CmdKLookupHint({ type, id }: CmdKLookupHintProps) {
  if (type === 'leadpool') {
    return (
      <div className="px-4 py-3 text-sm text-muted-foreground border-b">
        {id ? (
          <span>Select a campaign result to open its leadpool</span>
        ) : (
          <span>Type the campaign name after "leadpool:"</span>
        )}
      </div>
    );
  }

  if (type === 'base') {
    return (
      <div className="px-4 py-3 text-sm text-muted-foreground border-b">
        {id ? (
          <span>Select a base to open its leadpool</span>
        ) : (
          <span>Type the base name (or paste a base ID) after "base:"</span>
        )}
      </div>
    );
  }

  if (type === 'customer') {
    return (
      <div className="px-4 py-3 text-sm text-muted-foreground border-b">
        {id ? (
          <span>Select a customer from the results</span>
        ) : (
          <span>Type the customer name after "customer:"</span>
        )}
      </div>
    );
  }

  if (type === 'impersonate') {
    return (
      <div className="px-4 py-3 text-sm text-muted-foreground border-b">
        {id ? (
          <span>
            <kbd className="px-1.5 py-0.5 rounded bg-muted font-mono text-xs">
              Enter
            </kbd>{' '}
            opens a new impersonation tab ·{' '}
            <kbd className="px-1.5 py-0.5 rounded bg-muted font-mono text-xs">
              ⌘/Ctrl+Enter
            </kbd>{' '}
            copies the link
          </span>
        ) : (
          <span>Type a name or email after impersonate:</span>
        )}
      </div>
    );
  }

  return (
    <div className="px-4 py-3 text-sm text-muted-foreground border-b">
      {id ? (
        <span>
          Press{' '}
          <kbd className="px-1.5 py-0.5 rounded bg-muted font-mono text-xs">
            Enter
          </kbd>{' '}
          to go to {type} {id}
        </span>
      ) : (
        <span>Type the ID after "{type}:"</span>
      )}
    </div>
  );
}
